registerComponent("product-blocks/product-properties-cards", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O slick de 2020 (`slidesToShow: 4`, `2` abaixo de 767, `1` abaixo de 600,
 * `infinite: false`, **sem seta e sem ponto**) vira um `Asa.trilho` sobre a
 * `.wrap-cards`. Quem mede é o CSS: as três larguras de item estão no
 * `_product-properties-cards.less`, com a conta do que o slick rendia, e o
 * trilho lê de lá — nenhum `matchMedia` aqui.
 *
 * Como não havia seta nem ponto, o trilho não recebe controles: o que sobra
 * dele é o estado (`data-trilho`, `data-inicio`/`data-fim`) e o teclado. O
 * arrasto, a roda e o `scroll-snap` são do CSS.
 *
 * ⚠️ Este bloco não aparece em URL nenhuma do site hoje: o único fundo que o
 * declara é o `asa-metropolis`, que está `active = 0` — e `Product::active()`
 * no `Site\ProductController` devolve 404. Ver o relatório do sub-lote 8d.
 */

Asa.trilho(component.querySelector('.wrap-cards'), { itens: '.card', passo: 'pagina' });

});
